
<template class="max-w-lg">
  <div class="flex">
    <div class="w-full p-4 md:8 lg:p-16">
      <div class="w-full bg-white p-6 md:p-8 lg:p-12">
        <h2 class="text-3xl font-bold mb-6 text-left text-gray-800">Sign Up</h2>
        <form @submit.prevent="signup">
          <ErrorMessage v-if="showError" :message="errorMessage" :duration="5000"/>

          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">First Name</label>
            <input v-model="first_name" placeholder="Enter your first name" type="text" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required />
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">Last Name</label>
            <input v-model="last_name" placeholder="Enter your last name" type="text" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required />
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">Email</label>
            <input v-model="email" placeholder="user@example.com" type="email" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required />
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">Password</label>
            <div class="relative">
              <input
                v-model="password"
                @input="validatePassword"
                :type="showPassword ? 'text' : 'password'"

                placeholder="Enter your password"
                class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                required
              />
              <span 
                @click="togglePassword"
                class="absolute inset-y-0 right-2 flex items-center cursor-pointer"
              >
                <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 24 24"><title>
                  hide</title><g stroke-linejoin="miter" fill="#212121" stroke-linecap="butt" class="nc-icon-wrapper">
                  <path d="M1.373,13.183a2.064,2.064,0,0,1,0-2.366C2.946,8.59,6.819,4,12,4s9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366C21.054,15.41,17.181,20,12,20S2.946,15.41,1.373,13.183Z" fill="none" stroke="#212121" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></path><circle data-color="color-2" cx="12" cy="12" r="4" fill="none" stroke="#212121" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></circle><line data-color="color-2" x1="2" y1="22" x2="22" y2="2" fill="none" stroke="#212121" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2">
                </line></g></svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 24 24"><title>view</title><g stroke-linejoin="miter" fill="#212121" stroke-linecap="butt" class="nc-icon-wrapper"><path d="M1.373,13.183a2.064,2.064,0,0,1,0-2.366C2.946,8.59,6.819,4,12,4s9.054,4.59,10.627,6.817a2.064,2.064,0,0,1,0,2.366C21.054,15.41,17.181,20,12,20S2.946,15.41,1.373,13.183Z" fill="none" stroke="#212121" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></path><circle data-color="color-2" cx="12" cy="12" r="4" fill="none" stroke="#212121" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></circle></g></svg>
              </span>              
            </div>

            <div class="mt-2 text-[14px] grid grid-cols-1 md:grid-cols-2 gap-4">
              <div :class="getValidationClass(passwordCriteria.length)" class="flex items-center gap-2">
                At least 8 characters
                <span class="inline-block w-4 h-4">
                  <span v-if="passwordCriteria.length" class="text-green-500">✔</span>
                  <span v-else class="text-red-500">
                    <img src="@/assets/dashboard/iconoir_cancel.svg" alt="Close" class="w-5 h-5" />
                  </span>
                </span>                
              </div>
              <div :class="getValidationClass(passwordCriteria.uppercase)"  class="flex items-center gap-2">
                At least one uppercase letter
                <span class="inline-block w-4 h-4">
                  <span v-if="passwordCriteria.uppercase" class="text-green-500">✔</span>
                  <span v-else class="text-red-500">
                    <img src="@/assets/dashboard/iconoir_cancel.svg" alt="Close" class="w-5 h-5" />
                  </span>
                </span>
              </div>
              <div :class="getValidationClass(passwordCriteria.number)"  class="flex items-center gap-2">
                At least one number
                <span class="inline-block w-4 h-4">
                  <span v-if="passwordCriteria.number" class="text-green-500">✔</span>
                  <span v-else class="text-red-500">
                    <img src="@/assets/dashboard/iconoir_cancel.svg" alt="Close" class="w-5 h-5" />
                  </span>
                </span>
              </div>  
              <div :class="getValidationClass(passwordCriteria.specialChar)"  class="flex items-center gap-2">
                At least one special character
                <span class="inline-block w-4 h-4">
                  <span v-if="passwordCriteria.specialChar" class="text-green-500">✔</span>
                  <span v-else class="text-red-500">
                    <img src="@/assets/dashboard/iconoir_cancel.svg" alt="Close" class="w-5 h-5" />
                  </span>
                </span>
              </div>
            </div>
          </div>
          <button type="submit" class="w-full py-2 px-4 bg-primaryDarkBg hover:bg-primaryDark text-white font-bold rounded">Create an account</button>
        </form>

        <div class="space-y-4">
          <p class="mb-2 mt-4 text-grayDark">By clicking "Create account" above, you acknowledge that you have read, understood, and agree with Company's Privacy Policy and Terms Of Service</p>
          <hr class="w-full border-t-[1px] border-grayLight mb-6">
          <p class="mt-6 text-primaryDark flex justify-between items-center">Already have an account? 
            <router-link to="/login" class="text-primaryDark hover: px-3 py-2 bg-[#EEEEEE] rounded-md">Sign In</router-link>
          </p>          
        </div>
      </div>    
    </div>
    <div class="hidden md:block bg-[#F3F4F6] w-full  py-20">
      <p class="mb-2 -ml-8 mt-4 h-[60px] px-[68px] font-bold text-[64px]">"</p>
      <p class="mb-2 mt-4 font-bold text-5 px-[68px]">I can confidently say it has been a game changer for our team. Overall, this tool has significantly enhanced our productivity and collaboration!</p>
      <p class="mb-2 mt-4 text-5 px-[68px]">- Manuel Jephtah</p>
      <img src="@/assets/users/Frame12.png " alt="Close" class="-mr-12 pl-[68px]" />

      <!-- <div class="h-[871px] w-[630px] bg-primaryLight border border-[#EBEBED] border-4 -mr-12"></div> -->
    </div>    
  </div>
</template>
  
<script>
import apiClient from '@/axios';
import { useRouter } from 'vue-router'
import ErrorMessage from '../messages/ErrorMessage.vue';

export default {
  name: 'SignupView',
  components: {
    ErrorMessage,
  },
  data() {
    return {
      showPassword: false,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      password: '',
      showError: false,
      errorMessage: '',
      passwordCriteria: {
        length: false,
        uppercase: false,
        number: false,
        specialChar: false,
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  setup() {
    const router = useRouter()
    return { router }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    validatePassword() {
      const password = this.password;
      this.passwordCriteria.length = password.length >= 8;
      this.passwordCriteria.uppercase = /[A-Z]/.test(password);
      this.passwordCriteria.number = /[0-9]/.test(password);
      this.passwordCriteria.specialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);
    },
    getValidationClass(criteriaMet) {
      return criteriaMet ? 'text-primaryDark' : 'text-grayDark';
    },

    async signup() {
      this.showError = false;
      this.errorMessage = ''; 

      const isPasswordStrong = Object.values(this.passwordCriteria).every((value) => value);
        if (!isPasswordStrong) {
          const failures = [];
          if (!this.passwordCriteria.length) failures.push('at least 8 characters');
          if (!this.passwordCriteria.uppercase) failures.push('at least one uppercase letter');
          if (!this.passwordCriteria.number) failures.push('at least one number');
          if (!this.passwordCriteria.specialChar) failures.push('at least one special character');
          
          this.errorMessage = 'Password must contain: ' + failures.join(', ');
          this.showError = true;
          return;
        }

      try {
        const payload = {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          role: 'user',
          phone: this.phone,
          password: this.password,
          is_superuser: false,
          date_created: new Date().toISOString()
        }

        await apiClient.post('/web/users', payload, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        console.log('User account created')
        // this.router.push('/verify-email')
        this.$router.push({ name: 'VerifyEmail', params: { email: this.email } }); // Pass email as a route parameter

        // this.$router.push({ name: 'AwaitingApproval' });

      } catch (error) {
        this.errorMessage = error.response.data.message || 'Error creating user'

        //   if (error.response && error.response.status === 400) {
        //   if (error.response.data.message === 'Email already exists') {
        //     this.errorMessage = 'An account with this email address already exists.';
        //   } else {
        //     this.errorMessage = error.response.data.message || 'Error creating user'
        //   }
        // } else {
        //   // General error handling for other status codes
        //   this.errorMessage = 'An unexpected error occurred while creating user.';
        // }
        console.error('Error creating user:', error)
        this.showError = true;
      }
    }
  }
}
</script>

<style scoped>
/* Add your styles here */
</style>
  
